import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import LoadingSpinner from "./LoadingSpinner";

export default function OrderSubmissionModal(props) {
  const { isOpen } = props;

  return (
    <Modal isOpen={isOpen} className="order-submission-modal" size="md">
      <ModalBody>
        <LoadingSpinner text="Submitting Order"/>
      </ModalBody>
      <ModalFooter>
        <p className="submit-warning">
          Don't refresh this page or you could end up submitting the order twice.
        </p>
      </ModalFooter>
    </Modal>
  );
}
